// extracted by mini-css-extract-plugin
export var pGrid = "xh";
export var aLabel = "yh";
export var aTitle = "zh";
export var aImage = "Ah";
export var aText = "Bh";
export var aGrid = "Ch";
export var animationMarquee = "Dh";